import type { InternalNode, ReactFlowState } from '@xyflow/react';

import { Node } from '../types';
import { useGetValue } from './internal/useGetValue';

const selector = (s: ReactFlowState) =>
  Array.from(s.nodeLookup.values()).filter(
    (node) => !!node.selected
  ) as InternalNode<Node>[];

export function useSelectedNodes() {
  const { value: selectedNodes, get: getSelectedNodes } = useGetValue(selector);

  return { selectedNodes, getSelectedNodes };
}
